import { encryptStorage } from 'src/Util'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { loginDetail } from 'src/redux/actions/LoginActions'
import React, { useState, useRef, useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { Navigate, NavLink, BrowserRouter, useLocation, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { usersAPI } from '../../../redux/api'
import routx from 'src/routes'

function SessionTimeOut(props) {
  const location = useLocation()
  const [userLogged, setUserLogged] = useState(false)
  const idleTimerRef = useRef(null)
  const navigate = useNavigate()
  const userDetail = encryptStorage.getItem('session-user')
  const [userRoutes, setUserRoutes] = useState(['/login', '/logout', '/editor', '/faq'])

  useEffect(() => {
    if (userDetail) {
      setUserLogged(true)
      let tmpRouts = ['home']
      setUserRoutes(['/login', '/logout', '/editor', '/faq'])
      if (userDetail.menu_access != undefined) {
        userDetail.menu_access.map((item) => {
          if (item.menu_name) {
            tmpRouts.push(item.menu_name)
          }
          if (item.sub_menu && item.sub_menu.length > 0) {
            item.sub_menu.map((itemx) => {
              tmpRouts.push(itemx.menu_name)
            })
          }
        })
        routx.map((r) => {
          if (tmpRouts.includes(r.routeName)) {
            setUserRoutes((rts) => [...rts, r.path])
          }
          // console.log("tmpRouts::", tmpRouts, userRoutes, r.path);
        })
      }
    }
  }, [props.loginDetails])

  useEffect(() => {
    // console.log("xpath ",location.pathname);
    let xPath = location.pathname
    if (xPath.match(/\/editor/)) xPath = '/editor'
    // console.log("xpath ",xPath);
    if (xPath.match(/\/faq/)) xPath = '/faq'

    if (userRoutes.indexOf(xPath) == -1 && userDetail != undefined) {
      // console.log("location.pathname::", location.pathname, userRoutes);
      userDetail.role_name == 'Admin' ? navigate('/user-management') : navigate('/')
    }
    // console.log("111location.pathname::", location.pathname, userRoutes)
    if (userDetail != undefined && userDetail.role_name == 'Admin' && xPath == '/') {
      navigate('/user-management')
    }
  }, [location.pathname])

  const pageRefreshed = () => {
    if (location.pathname == '/aiCheck' || location.pathname == '/trial') {
      navigate('/trial')
    } else {
      navigate('/login')
      navigate(0)
    }

    setUserLogged(false)
    window.removeEventListener('beforeunload')
  }

  const onIdle = () => {
    console.log('user is idle')
    window.addEventListener('beforeunload', pageRefreshed)
    if (location.pathname !== '/trial') {
      Swal.fire({
        icon: 'warning',
        scrollbarPadding: false,
        title: 'Session Expired',
        text: 'Your session has expired.Please Login again',
        confirmButtonText: 'OK',
        confirmButtonColor: 'rgba(0, 171, 103, 1)',
        focusConfirm: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((res) => {
        // console.log(res)
        if (res.value || res.isDismissed) {
          let reqBody = {
            user_id: userDetail?.user_id,
            company_id: userDetail?.company_id,
            session_id: userDetail?.sessionId,
            action: 'Logout success',
          }
          usersAPI.post('/user/user-action', reqBody).then((response) => {
            console.log('User action updated----', response?.data?.status)
          })
          console.log('logout clicked')
          if (location.pathname == '/aiCheck' || location.pathname == '/trial') {
            sessionStorage.setItem('trial-user-authenticated', false)
            navigate('/trial')
            window.location.href = '#/trial'
            window.location.reload()
          } else {
            navigate('/login')
            navigate(0)
          }
          setUserLogged(false)
          console.log('after click logged', userLogged)
          document.title = 'AccessibilityInsight'
        }
      })
    }
  }
  const idleTimer = useIdleTimer({
    ref: idleTimerRef,
    onIdle: userLogged
      ? onIdle
      : () => {
          console.log('not logged')
        },
    //timeout:30*60*1000,
    timeout: 3600 * 1000,
    crossTab: true,
    //timeout:20*1000
  })
  console.log('user logged', userLogged)

  return (
    console.log('is user logged', userLogged),
    (<>{userLogged ? <div idletimer={idleTimer}></div> : console.log('hi guest')}</>)
  )
}
const mapStateToProps = (state) => {
  return {
    // will be available as props.trips
    loginDetails: state?.login?.loginDetails,
  }
}

SessionTimeOut.propTypes = {
  loginDetails: PropTypes.object,
}

export default connect(mapStateToProps, { loginDetail })(SessionTimeOut)
